import Vue from 'vue'
import App from './App.vue'
import crypto from './crypto/crypto'
import router from './router'
import store from './store'
import axios from 'axios'
import plug from './plug/index'
import Http from './http/index'
import Https from './utils/https.js'
// import './utils/fontsize.js'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import {Row, Col} from 'iview';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import common from './common'
import animate from 'animate.css';
import 'animate.css'
import {WOW} from 'wowjs'
import VueLazyload from 'vue-lazyload'
import VueI18n from 'vue-i18n'

Vue.prototype.$crypto = crypto

Vue.prototype.axios = axios;
Vue.prototype.$http = Http
Vue.prototype.$https = Https
Vue.prototype.$uuid = require('uuid')
Vue.use(plug)
Vue.use(iView)
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.use(ElementUI);
Vue.prototype.common = common
Vue.use(animate);
Vue.use(VueI18n);
Vue.prototype.$wow = new WOW({
    boxClass: 'wow', // default
    animateClass: 'animated', // default
    offset: 150, // default
    mobile: true, // default
    live: true, // default
    callback: function (box) {
        window.scrollTo(0, 0);
    }
})

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('./assets/images/default.png'),
    loading: require('./assets/images/loading.gif'),
    lazyComponent: true
})
const i18n = new VueI18n({
    locale: 'mn',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh': require('./assets/lang/zh'),   // 中文语言包
        'mn': require('./assets/lang/mn'),    // 蒙文语言包
        'en': require('./assets/lang/en')    // 英文语言包
    }
})


// 注册转码过滤器 U2M
Vue.filter('U2M', function (value) {
    return Unicode2M(value);
})
// 注册转码过滤器 M2U
Vue.filter('M2U', function (value) {
    return M2Unicode(value);
})
Vue.prototype.U2M = function (value) {
    //changeData是函数名
    let filetered = Unicode2M(value);
    return filetered;
}
Vue.prototype.M2U = function (value) {
    //changeData是函数名
    let filetered = M2Unicode(value);
    return filetered;
}


Vue.config.productionTip = false

/************************************************************
 *
 * 检索时失去焦点
 *
 ************************************************************/
Vue.prototype.$getOnBlur = function (data) {
    let old = data.trim()
    // // 奥云
    // let aoyun = '\s+ᠵᠢᠨ|\s+᠊ᠤᠨ|\s+᠊ᠦ|\s+ᠳ᠋ᠤ᠌|\s+ᠲᠤ᠌|\s+ᠶ᠋ᠢ|\s+᠊ᠢ|\s+ᠠ᠋ᠴᠠ|\s+ᠲᠠᠢ|\s+ᠪᠠᠷ|\s+ᠵᠢᠠᠷ|\s+ᠪᠡᠨ|\s+ᠵᠢᠠᠨ|\s+ᠳ᠋ᠦ᠍ᠷ|\s+ᠲᠤᠷ|s+᠊ᠤᠤ'
    // // 德力海
    // let delihai = '|\s+ᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠢ|\s+ᠵᠢ|\s+᠎ᠳᠤ|\s+᠎ᠲᠤ|\s+᠎ᠲᠠᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠪᠡᠷ|\s+᠎ᠢᠶᠡᠨ|\s+᠎ᠪᠡᠨ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠳᠤᠷ|\s+᠎ᠲᠤᠷ'
    // // 蒙科力标准
    // let mklbz = '|\s+ᠤᠨ|\s+ᠪᠠᠷ|\s+ᠶ᠋ᠢ|\s+ᠪᠠᠷ|\s+ᠪᠠᠨ|\s+ᠤᠳ|\s+ᠦᠦ'
    // // 蒙科力
    // let mkl = '|\s+ᠶᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠳ᠋ᠦ᠍|\s+᠎ᠲᠤ|\s+ᠶᠢ|\s+᠎ᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠲᠠᠢ|\s+᠎ᠪᠠᠷ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠪᠠᠨ|\s+᠎ᠢᠶᠡᠨ|\s+ᠦᠦ'
    let reg = /\s+ᠵᠢᠨ|\s+᠊ᠤᠨ|\s+᠊ᠦ|\s+ᠳ᠋ᠤ᠌|\s+ᠲᠤ᠌|\s+ᠶ᠋ᠢ|\s+᠊ᠢ|\s+ᠠ᠋ᠴᠠ|\s+ᠲᠠᠢ|\s+ᠪᠠᠷ|\s+ᠵᠢᠠᠷ|\s+ᠪᠡᠨ|\s+ᠵᠢᠠᠨ|\s+ᠳ᠋ᠦ᠍ᠷ|\s+ᠲᠤᠷ|s+᠊ᠤᠤ|\s+ᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠢ|\s+ᠵᠢ|\s+᠎ᠳᠤ|\s+᠎ᠲᠤ|\s+᠎ᠲᠠᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠪᠡᠷ|\s+᠎ᠢᠶᠡᠨ|\s+᠎ᠪᠡᠨ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠳᠤᠷ|\s+᠎ᠲᠤᠷ|\s+ᠤᠨ|\s+ᠪᠠᠷ|\s+ᠶ᠋ᠢ|\s+ᠪᠠᠷ|\s+ᠪᠠᠨ|\s+ᠤᠳ|\s+ᠦᠦ|\s+ᠶᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠳ᠋ᠦ᠍|\s+᠎ᠲᠤ|\s+ᠶᠢ|\s+᠎ᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠲᠠᠢ|\s+᠎ᠪᠠᠷ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠪᠠᠨ|\s+᠎ᠢᠶᠡᠨ|\s+ᠦᠦ/g
    let ss = old.replace(reg, "-");
    let ll = ss.split("-").filter(item => item).join(" ")
    let ss1 = ll.replace(/\s+/g, "-")
    let ll1 = ss1.split("-").filter(item => item).join(" ")
    return ll1
}

function changeThemeColor(color) {
    document.body.style.setProperty('--themeColor', color);
}

//获取馆藏信息
function getVUE_APP_BASE_NUMBER(number_id, next) {

    Http.get('api/web/v1/h5/search?library_id=' + number_id).then(val => {
        // console.log('馆藏信息', val)
        localStorage.setItem('gcmTime', new Date().getTime())
        let a = {
            theme_color: val.data.theme_color,
            library_id: number_id,
            library_num: val.data.number,
            content: val.data.content_lang ? (val.data.content_lang.zh || val.data.content_lang.mn) : '',
            logo_icon: val.data.logo_icon ? val.data.logo_icon : ''
        }
        changeThemeColor(val.data.theme_color)
        localStorage.setItem('theme_color', Vue.prototype.$crypto.set(JSON.stringify(a)))
        store.commit('SET_theme_color', a)
        getVUE_LIBRARY_ID(number_id)

    }).catch(err => {
        if (err.code == 400) {
            return
        }
    })
}

function getVUE_LIBRARY_ID(number_id) {
    Http.get('api/web/v1/h5/getLibraryIdDecrypt?password=' + number_id).then(val => {
        // console.log('馆藏码解密', val)
        if (val.info.code == 200) {
            if (val.data) {
                let a = JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('theme_color')))
                a.number_id = val.data
                localStorage.setItem('theme_color', Vue.prototype.$crypto.set(JSON.stringify(a)))
                store.commit('SET_theme_color', a)
            }
        }
    })
}

/************************************************************
 *
 * 保存用户行为
 *
 ************************************************************/
function saveUserBehavior(to, from) {
    let data = {
        member_id: localStorage.getItem('userInfoMemberId') ? JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfoMemberId'))).member_id : null,// 用户id
        library_id: localStorage.getItem('theme_color') ? JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('theme_color'))).number_id : null,// 馆藏id
        book_id: null,// 数据ID（书籍id、期刊id）
        magazine_id: null,// 杂志id
        type: to.meta.type,// 类型 1书籍 2杂志
        path: to.path,// 路由
        name: to.meta.title ? to.meta.title : '',//名称
        terminal: 7,//1阿启泰书籍文献APP、2阿启泰优质资源P端、3阿启泰蒙医药资源库PC、4阿启泰蒙医药资源库APP  6图书馆门户网站 7统一检索
        wificode: store.getters.wificode,// Wi-Fi码
        devicecode: store.getters.uuid,//设备码
        network: store.getters.network,// 网络
        latlon: store.getters.latlon,// 经纬度
        ip: '',//网络ip
        apiterminal:'Aqt_20230517ApiWeb'
    }

    //  书籍详情+期刊详情+报刊详情+知识库详情+作者详情+儿童名详情
    if (to.path == '/booksInfos' || to.path == '/journalInfos'
    ) {
        data.book_id = to.query.id
        data.magazine_id = null
    }
    if (to.path == '/trendsInfor') {
        data.book_id = to.query.news_id
        data.magazine_id = null
    }

    axios.post('https://culture.aqitai.com/api/web/v1/book/userbehavior', data).then(val => {
    }).catch(err => {
    })

}


/************************************************************
 *
 * 判断当前设备是移动端还是pc端
 *
 ************************************************************/
function browserRedirect() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        console.log("动端页面");
        Vue.prototype.$isMobile=true
    } else {
        console.log('pc端页面')
        Vue.prototype.$isMobile=false
    }
}
/** 跳路由置顶 */
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

router.beforeEach((to, from, next) => {
    browserRedirect()

    if (!to.query.number) {
        return;
    }

    var gcm = to.query.number ? to.query.number : ''

    var gcmTime = localStorage.getItem('gcmTime')?localStorage.getItem('gcmTime'):null
    var nowTime = Date.now();
    if(gcmTime){
        if(nowTime - gcmTime> 6*60*60*1000){
            //超出12小时了
            localStorage.removeItem("gcm");
        }else {
            //12小时内
        }
    }else {
        localStorage.removeItem("gcm");
    }


    if (!localStorage.getItem('gcm') || localStorage.getItem('gcm') != gcm || !localStorage.getItem('theme_color')) {
        if (gcm) {
            localStorage.setItem('gcm', gcm)
        }
        let number_id = localStorage.getItem('gcm')
        getVUE_APP_BASE_NUMBER(number_id, next)
        //切换馆藏清除用户信息
        localStorage.removeItem("userInfoMemberId");
        localStorage.removeItem("userInfos");
        store.commit("SET_UserInfor", '');
    }


    store.dispatch('getSebeihao').then(() => {
    })
    store.dispatch('getNetworkType').then(() => {
    })
    store.dispatch('getMap').then(() => {
    })

    // 保存用户行为
    if (localStorage.getItem('theme_color')) {
        setTimeout(function () {
            saveUserBehavior(to, from)
        }, 300)
    }

    if (!localStorage.getItem('userInfoMemberId') && to.path != `/login_zh` && to.path != `/index`) {
        next(`/login_zh?number=${localStorage.getItem('gcm')}`)
    } else {
        next()
    }
})

window.Vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
